<template>
  <v-row style="overflow: auto">
    <Loading v-if="isLoading"/>
    <v-col md="7" lg="7" class="pt-0">
      <v-simple-table class="table-full table-fixed-height pt-3" :fixed-header="true" style="border-right: 1px solid #e0e0e0;border-bottom: 1px solid #e0e0e0;border-radius: 0;">
        <thead>
          <tr>
            <th>ID</th>
            <th>NOM</th>
            <th>PRÉNOM</th>
            <th>EMAIL</th>
            <th>TÉLÉPHONE</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(item, index) in data">
            <td>{{ item.id }}</td>
            <td>{{ item.lastName }}</td>
            <td>{{ item.firstName }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.telephone }}</td>
            <td>
              <v-icon x-small @click="setUserForm(item)">fa fa-edit</v-icon>
              <v-icon x-small style="padding-left: 10px" @click="remove(item)" v-if="!Array.isArray(item.roles) || item.roles.findIndex(role => role === 'ROLE_ADMIN_SUPPER') === -1">fa fa-trash</v-icon>
            </td>
          </tr>

        </tbody>
      </v-simple-table>

      <div class="mt-4 mb-1 mx-4" v-if="data.length > 0">
        <v-pagination class="justify-start" v-model="currentPage" :length="totalPage"></v-pagination>
      </div>
    </v-col>
    <v-col md="4" lg="3" class="pl-8">
      <v-card flat class="mt-0">
        <ValidationObserver ref="form" v-slot="{ validate, reset }">
          <v-form>
          <v-card-text class="pa-0 mt-4">
            <v-row>
              <v-col cols="12" class="py-0 mb-8">
                <h2
                  class="primary--text font-weight-light mr-3 text-uppercase"
                >Ajouter / Éditer un utilisateur</h2>
              </v-col>
              <v-col cols="12" class="py-0 mb-4">
                <ValidationProvider v-slot="{ errors }" :name="'Role'" rules="required">
                  <p class="label">Role</p>
                  <v-select
                          :error-messages="errors"
                          :items="roles"
                          v-model="userForm.role"
                          hide-details="auto"
                          outlined
                    >
                  </v-select>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" class="py-0 mb-4">
                <ValidationProvider v-slot="{ errors }" :name="$t('Civilité')" rules="required">
                  <p class="label">Civilité</p>
                  <v-radio-group
                    v-model="userForm.gender"
                    row
                    required
                    class="mt-2"
                    hide-details
                    :error-messages="errors"
                  >
                    <v-radio label="M." :value="1"></v-radio>
                    <v-radio label="Mme." :value="0" class="mr-0"></v-radio>
                  </v-radio-group>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" class="py-0 mb-4">
                <ValidationProvider v-slot="{ errors }" :name="$t('Username')" rules="required">
                  <p class="label">Username</p>
                  <v-text-field
                          :error-messages="errors"
                          placeholder
                          hide-details="auto"
                          v-model="userForm.username"
                          outlined
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
               <v-col cols="12" class="py-0 mb-4" v-if="!userForm.id">
                <ValidationProvider v-slot="{ errors }" :name="$t('Mot de passe')" rules="required|min:6">
                    <p class="label">Mot de passe</p>
                    <v-text-field
                      placeholder
                      hide-details="auto"
                      v-model="userForm.password"
                      outlined
                      :error-messages="errors"
                      autocomplete="new-password"
                      :type="'password'"></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" class="py-0 mb-4" v-else>
                  <p class="label">Mot de passe</p>
                  <v-text-field
                    placeholder
                    hide-details="auto"
                    v-model="userForm.password"
                    outlined
                    :type="'password'"
                  ></v-text-field>
              </v-col>
              <v-col cols="12" class="py-0 mb-4">
                <ValidationProvider v-slot="{ errors }" :name="$t('Nom')" rules="required">
                    <p class="label">Nom</p>
                    <v-text-field
                      :error-messages="errors"
                      placeholder
                      hide-details="auto"
                      v-model="userForm.lastName"
                      outlined
                    ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" class="py-0 mb-4">
                <ValidationProvider v-slot="{ errors }" :name="$t('Prénom')" rules="required">
                    <p class="label">Prénom</p>
                    <v-text-field
                      :error-messages="errors"
                      placeholder
                      hide-details="auto"
                      v-model="userForm.firstName"
                      outlined
                    ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" class="py-0 mb-4">
                <ValidationProvider v-slot="{ errors }" :name="$t('Email')" rules="required|email">
                    <p class="label">Email</p>
                    <v-text-field
                      :error-messages="errors"
                      placeholder
                      hide-details="auto"
                      v-model="userForm.email"
                      outlined
                      type="email">
                    </v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" class="py-0 mb-4">
                <ValidationProvider v-slot="{ errors }" :name="$t('Téléphone')" rules="required">
                    <p class="label">Téléphone</p>
                    <v-text-field
                      :error-messages="errors"
                      placeholder
                      hide-details="auto"
                      v-model="userForm.telephone"
                      autocomplete="new-telephone"
                      outlined
                    ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>

          <div class="text-center">
            <v-btn class="ma-2" depressed rounded color="primary" @click="save">{{$t('Save')}}</v-btn>
            <v-btn class="ma-2 black--text" depressed rounded color="#E1E1E1" @click="resetForm">{{$t('Cancel')}}</v-btn>
          </div>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-col>
  </v-row>
</template>


<script>
  import UserService from "../../services/user.service";
  import {ValidationObserver, ValidationProvider} from "vee-validate";
  import Loading from '../../components/Loading.vue';
  export default {
  name: "UserCommercial",
  components: {
    ValidationObserver,
    ValidationProvider,
    Loading
  },
  data() {
    return {
      currentPage: 1,
      resultsPerPage: 10,
      totalPage: 1,
      data: [],
      isLoading: false,
      roles: [
        {
          value: 'ROLE_ADMIN_SUPPER',
          text: 'Supper admin'
        },
        {
          value: 'ROLE_ADMIN',
          text: 'Admin'
        }
      ],
      userForm: {
        username: '',
        firstName: '',
        lastName: '',
        email: '',
        telephone: '',
        password: '',
        status: 1,
        role: ''
      }
    };
  },
  created() {
    this.getListUser();
  },
  methods: {
    setUserForm(item) {
      this.userForm = {...item, role: Array.isArray(item.roles) ? item.roles.slice(0, 1).shift() : ''};
    },
    async getListUser() {
      this.isLoading = true;
      const req = await UserService.getPagedResult(
        this.currentPage,
        this.resultsPerPage,
        null,
        null,
        null,
        []
      );
      if(req) {
        this.totalPage = req.data.totalPage;
        this.currentPage = req.data.currentPage;
        this.data = req.data.data;
      }
      this.isLoading = false;
    },
    async save() {
      this.isLoading = true;
      let req = null;
      let userForm = {...this.userForm, roles: [this.userForm.role]};

      if(this.userForm.id) {
        req = await UserService.update(userForm.id, userForm);
      } else {
        const validate = await this.$refs.form.validate();
        if(validate) {
          req = await UserService.create(userForm);
        }
      }
      if(req) {
        this.getListUser();
        this.resetForm();
      } else {
        this.isLoading = false;
      }
    },
    async remove(item) {
      try {
        if (!await this.confirm('Voulez-vous supprimer ?')) {
          return;
        }

        this.isLoading = true;

        await UserService.delete(item.id);

        this.getListUser();
        // this.isLoading = false;
      } catch (e) {
        this.handleError(e);
        this.isLoading = false;
      }
    },
    async resetForm() {
      this.userForm = {
        id: null,
        firstName: '',
        lastName: '',
        email: '',
        telephone: '',
        password: '',
        status: 1,
        role: ''
      };

      this.$refs.form.reset();
    }
  }
};
</script>
